import React from 'react';
import { css } from 'linaria';
import {
	Container,
	ModalContainer,
	PageBreadcrumbs,
	PageTitle,
	StoreBlock,
	StoreSelectionModal,
} from '../../../common/components';
import { useInstore } from '../hooks';
import { CardsContainer, PageAdditionalInfo } from './components';

const pageTitleMargin = css`
	margin-bottom: 0;
`;

export const InstoreServicesList = () => {
	const {
		isModalOpen,
		openModal,
		closeModal,
		selectedStoreCode,
		selectedStoreData,
		stores,
	} = useInstore();

	return (
		<Container data-qa="instore-services-list-page">
			<PageBreadcrumbs />
			<PageTitle className={pageTitleMargin} />
			<StoreBlock
				selectedStoreCode={selectedStoreCode}
				selectedStoreData={selectedStoreData}
				storesCount={stores.length}
				onClick={openModal}
			/>
			<CardsContainer />
			<PageAdditionalInfo />
			<ModalContainer isOpen={isModalOpen} onClose={closeModal} variant="curtain">
				<StoreSelectionModal selectedStoreCode={selectedStoreCode} storesList={stores} />
			</ModalContainer>
		</Container>
	);
};
